import { parseIntegerValue } from 'src/utils/parseIntegervalue.ts';

export const compareAsNumbers = (a: string, b: string): number => {
    if (a === b) {
        return 0;
    }
    try {
        const parsedA = parseIntegerValue(a);
        const parsedB = parseIntegerValue(b);
        return parseFloat(parsedA) > parseFloat(parsedB) ? 1 : -1;
    } catch {
        return 0;
    }
};
